/**   the interface for the viewer for editing the graph layout, and the graph */
export var InsertionMode;
(function (InsertionMode) {
    InsertionMode[InsertionMode["Default"] = 0] = "Default";
    InsertionMode[InsertionMode["Node"] = 1] = "Node";
    InsertionMode[InsertionMode["Edge"] = 2] = "Edge";
})(InsertionMode || (InsertionMode = {}));
//# sourceMappingURL=iViewer.js.map